import { Component, OnInit } from '@angular/core';
import { Tooltip } from 'bootstrap';


@Component({
  selector: 'app-trs-sm-timer',
  templateUrl: './trs-sm-timer.component.html',
  styleUrls: ['./trs-sm-timer.component.sass']
})
export class TrsSmTimerComponent implements OnInit {
  hours=0;
  seconds=0;
  minutes=0;
  constructor() {
    

   }

  ngOnInit(): void {

    setInterval(() => {
      this.seconds++;
      if(this.seconds  === 60) {
        this.seconds = 0;
        this.minutes++;
        if(this.minutes === 60) {
          this.minutes = 0;
          this.hours++;
        }
      }
    },1000)
  }

}
